import { _ep0, _mw0, command } from "../commandBuilder";
import { UpdateAnalytics$ } from "../schemas/schemas_0";
export class UpdateAnalyticsCommand extends command(_ep0, _mw0, "UpdateAnalytics", UpdateAnalytics$) {
}
